import { ACTIONS } from "../../common/constants";

const commisionsDataReducer = function (state = false, action) {
  switch (action.type) {
    case ACTIONS.SET_COMMISIONS_DATA:
      return action.data;
    default:
      return state;
  }
};

export default commisionsDataReducer;
